import { render, staticRenderFns } from "./Lista.vue?vue&type=template&id=438ef242&scoped=true&lang=pug"
import script from "./Lista.vue?vue&type=script&lang=js"
export * from "./Lista.vue?vue&type=script&lang=js"
import style0 from "./Lista.vue?vue&type=style&index=0&id=438ef242&prod&lang=scss"
import style1 from "./Lista.vue?vue&type=style&index=1&id=438ef242&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438ef242",
  null
  
)

export default component.exports